<template>
    <v-menu offset-y>
        <template v-slot:activator="{ on, attrs }">
            <v-btn icon color="#fff" v-bind="attrs" v-on="on">
                <v-badge :value="badge" color="red" dot bordered overlap>
                    <v-icon>mdi-alert-circle</v-icon>
                </v-badge>
            </v-btn>
        </template>
        <v-list style="min-height: 1px; max-height: calc(100vh - 25px);">
            <template v-if="badge">
                <v-list-item
                class="item-menu-text"
                x-small
                v-for="(item, index) in listRequest"
                :key="index"
                >
                <router-link style="width: 100%;" :to="'/user/'" class="d-flex flex-nowrap justify-lg-space-between">
                   <div style="margin: 5px 0;" class="d-flex flex-column align-start">
                        <v-list-item-title>{{ item.slug | translaterSlug }} (№ {{item.id}})</v-list-item-title>
                        <v-list-item-subtitle>{{ checkSlug(item.slug) }}</v-list-item-subtitle>
                   </div>
                    <v-list-item-action>
                        <v-icon :color="$mainColor" >mdi-chevron-double-right</v-icon>
                    </v-list-item-action>
                </router-link>
                </v-list-item>
            </template>
            <v-list-item v-else>
                <v-list-item-title>{{$t('no_data')}}</v-list-item-title>
            </v-list-item>
        </v-list>
    </v-menu>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
export default {
    name: 'notificationBadge',
    async beforeMount() {
        await this.slugLengthRequest()
    },
    data() {
        return {
            badge: false,
            listRequest: [],
            listSlug: ['modification', 'approve'],
        }
    },
    computed: {
        ...mapGetters(['GETTERS_LOGIN', 'GETTERS_APP_LANGUAGE_NTRANSLATE'])
    },
    filters: {
        translaterSlug(val) {
            if (val === 'modification') return 'modification';
            if (val === 'approve') return 'approve';
        }
    },
    methods: {
        ...mapActions(['GET_LIST_ROLE_BAGE']),
        async slugLengthRequest() {
        
            this.listRequest = []

            await this.GET_LIST_ROLE_BAGE()
            .then(res => {
                if (res.data.length !== 0) {
                    this.listRequest = res.data
                    this.badge = true
                }
            })
        },
        checkSlug(slug) {
            if (slug === 'approve') return this.$t('NotificationBadge.approveMessage')
            if (slug === 'modification') return this.$t('NotificationBadge.modificationMessage')
        }
    },
    watch: {
        GETTERS_APP_LANGUAGE_NTRANSLATE() {
            this.slugLengthRequest()
        }
    }
}
</script>
<style scoped>
.item-menu-text {
    font-size: 13px;
    line-height: 15px;
}
.v-list-item__title {
    align-self: flex-start;
}
.item-menu-text {
    z-index: 999;
    background: white;
}
</style>